module.exports = __webpack_public_path__ + "static/media/mobile_background.cdd15bf6.jpg";